
import { useState } from "react";
import { FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "@/types/loan";
import { LegalDialogs } from "./LegalDialogs";
import { useNavigate } from "react-router-dom";

interface FinnishTermsCheckboxProps {
  form: UseFormReturn<FormValues>;
  setTermsOpen: (value: boolean) => void;
  setPrivacyPolicyOpen: (value: boolean) => void;
}

export const FinnishTermsCheckbox = ({ 
  form, 
  setTermsOpen, 
  setPrivacyPolicyOpen 
}: FinnishTermsCheckboxProps) => {
  const [localTermsOpen, setLocalTermsOpen] = useState(false);
  const [localPrivacyOpen, setLocalPrivacyOpen] = useState(false);
  const navigate = useNavigate();

  // Set marketing consent to true by default
  useState(() => {
    if (form.getValues("marketingConsent") === undefined) {
      form.setValue("marketingConsent", true);
    }
  });

  const handleTermsClick = () => {
    setLocalTermsOpen(true);
  };

  const handlePrivacyClick = () => {
    setLocalPrivacyOpen(true);
  };

  return (
    <div className="space-y-1 pt-0.5 checkbox-container">
      <FormField
        control={form.control}
        name="termsAccepted"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-2 space-y-0">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
                className="data-[state=checked]:bg-blue-600 data-[state=checked]:border-blue-600 mt-0.5"
              />
            </FormControl>
            <div className="leading-none">
              <label
                htmlFor="termsAccepted"
                className="text-xs font-medium leading-tight peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                <span className="whitespace-nowrap">Olen lukenut ja hyväksyn</span>{" "}
                <button
                  type="button"
                  className="text-blue-600 hover:underline font-medium"
                  onClick={handleTermsClick}
                >
                  käyttöehdot
                </button>{" "}
                <span className="whitespace-nowrap">ja</span>{" "}
                <button
                  type="button"
                  className="text-blue-600 hover:underline font-medium"
                  onClick={handlePrivacyClick}
                >
                  tietosuojaselosteen
                </button>
              </label>
              <FormMessage className="text-xs mt-0.5" />
            </div>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="marketingConsent"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-2 space-y-0 mt-1">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
                className="data-[state=checked]:bg-blue-600 data-[state=checked]:border-blue-600 mt-0.5"
              />
            </FormControl>
            <div className="leading-none">
              <label
                htmlFor="marketingConsent"
                className="text-xs font-medium leading-tight peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Haluan saada hyödyllisiä vinkkejä ja tietoja lainoista sähköpostiini
              </label>
            </div>
          </FormItem>
        )}
      />

      <LegalDialogs
        termsOpen={localTermsOpen}
        setTermsOpen={setLocalTermsOpen}
        privacyPolicyOpen={localPrivacyOpen}
        setPrivacyPolicyOpen={setLocalPrivacyOpen}
        language="fi"
        openFullTerms={() => {
          setLocalTermsOpen(false);
          navigate("/kayttoehdot"); 
        }}
        openFullPrivacy={() => {
          setLocalPrivacyOpen(false);
          navigate("/tietosuojaseloste");
        }}
      />
    </div>
  );
};
